// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_k1-0";
export var animationContainer = "_k1-1";
export var itemPrice = "_k1-a";
export var itemizedContent = "_k1-9";
export var itemizedHeader = "_k1-7";
export var itemizedRow = "_k1-8";
export var itemizedSection = "_k1-6";
export var modalContent = "_k1-2";
export var orderName = "_k1-3";
export var refundOption = "_k1-4";
export var refundOptionsContainer = "_k1-5";
export var shippingLabel = "_k1-b";
export var totalRow = "_k1-c";